import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const IsUseKmTariffField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = restaurantForFullInfo?.commissionTariff === 'KATEMEDIA';
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			label="kmTariffLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
